import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import { Icon, IconButton, TextField, Typography } from '@material-ui/core'
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {FuseAnimate} from '@fuse';

class VipHeader extends Component {

    componentDidMount() {
        let event = {target: {value: ''}};
        this.props.setSearchText(event);
    }

    render() {
        const {classes, reload} = this.props;
        return (
            <div
                className={classNames(classes.root, "flex flex-1 flex-col sm:flex-row items-center justify-between p-24")}>

                <div className="flex flex-1 items-center">
                    <div className="flex items-center">
                        <FuseAnimate animation="transition.expandIn" delay={300}>
                            <Icon className="text-32 mr-12">account_box</Icon>
                        </FuseAnimate>
                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                            <Typography variant="title">會員列表</Typography>
                        </FuseAnimate>
                        {reload && <IconButton onClick={reload}>
                            <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                <Icon className="text-32 mr-12">refresh</Icon>
                            </FuseAnimate>
                        </IconButton>}
                    </div>
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    root: {}
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setSearchText: ReduxGlobal.ActionCreator.setSearchText
    }, dispatch);
}

function mapStateToProps({global: {searchText}}) {
    return {searchText};
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(VipHeader));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/vip/VipHeader.js